/**
 * Created by Alan Yang on 5/08/2019.
 * Description:
 * Ag-grid copy button
  * ------ maintenance history ------
  * 06/16/2019 Bowen Li - add tooltip for smart-icon
  * 07/03/2019 Ella Ma - modify dashboard router query params
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Router } from '@angular/router';

@Component({
    selector: 'tam-manage-screens-copy-button',
    template: `<div kendoTooltip position="bottom"><smart-icon #anchor name='copy' class='smart-icon light' (click)='clicked($event)'title="Copy"></smart-icon></div>`,
    styleUrls: ['./manage-screens.component.scss']
})
export class ManageScreensCopyButtonComponent implements ICellRendererAngularComp {
    private _dashboardId: string;
    constructor(
        private _router: Router,
    ) { }

    agInit(params: any): void {
        this._dashboardId = params.data.id;
    }

    clicked(cell: any): void {
        this._router.navigate(['dashboard/copy', this._dashboardId], {
            queryParams: {
                from: 'settings'
            }
        });
    }

    refresh(): boolean {
        return false;
    }
}
